import React from "react";
import { List } from "@mui/material";
import { getCategory } from "../../configuration/navMenuConfiguration";
import NavMenuCategory from "../NavMenuCategory";
import { NavSubMenu } from "../NavSubMenu";

export type MenuItem = {
  id?: string;
  label?: string;
  url?: string;
  selected?: boolean;
  navBar?: boolean;
  categoryId?: string;
};

export type NavigationConfig = {
  categoryId: string;
  items: MenuItem[];
};

type NavMenuProps = {
  navigation: NavigationConfig;
};

export default function NavMenu(props: NavMenuProps) {
  const items = props.navigation.items;
  const category = getCategory(props.navigation.categoryId);

  return (
    <List
      disablePadding
      sx={{
        paddingBottom: "32px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <NavMenuCategory category={category} key={category.id} />
      {items.map((item) => {
        return <NavSubMenu menuItem={item} key={item.id} />;
      })}
    </List>
  );
}
